export const products = [
  {
    id: 1,
    name: "에코백",
    type: "에코백",
    price: 22000,
    img: "https://s3.marpple.co/files/u_1686012/2022/4/original/9f1c97f4723f535f95f27ae6b23507166260c31f1.jpg",
    badges: ["에코백"],
    sku: "ECOBAG-01",
    widthCm: 38,
    heightCm: 40,
    tagline: "친환경에 이바지하는 에코백입니다.",
    hasSizes: false,
  },
  {
    id: 2,
    name: "키링",
    type: "키링",
    price: 19000,
    img: "https://static.vecteezy.com/system/resources/previews/055/252/078/large_2x/card-on-a-keychain-with-a-chain-without-background-vector.jpg",
    badges: ["키링"],
    sku: "KEYRING-01",
    widthCm: 5,
    heightCm: 5,
    tagline: "개성을 더하는 키링 액세서리입니다.",
    hasSizes: false,
  },
  {
    id: 3,
    name: "후드티",
    type: "후드티",
    price: 22000,
    img: "/Hood.jpg",
    badges: ["후드티"],
    sku: "HOODIE-01",
    widthCm: 58,
    heightCm: 70,
    tagline: "쌀쌀한 가을에 입기 좋은 후드티입니다.",
    hasSizes: true,
    sizes: ["S", "M", "L", "XL"],
  },
  {
    id: 4,
    name: "티셔츠",
    type: "티셔츠",
    price: 15000,
    img: "https://img.freepik.com/free-vector/hand-drawn-t-shirt-outline-illustration_23-2150923017.jpg?semt=ais_hybrid&w=740&q=80",
    badges: ["티셔츠"],
    sku: "TSHIRT-01",
    widthCm: 52,
    heightCm: 70,
    tagline: "일상에 편안함을 더하는 반팔 티셔츠입니다.",
    hasSizes: true,
    sizes: ["S", "M", "L", "XL"],
  },
];

export const findProductBySku = (sku) => products.find((p) => p.sku === sku);


